import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { injectIntl } from 'react-intl-next';
import { alignmentMessages as messages } from '@atlaskit/editor-common/messages';
import { expandIconContainerStyle, separatorStyles, triggerWrapperStylesWithPadding } from '@atlaskit/editor-common/styles';
import { ArrowKeyNavigationType, DropdownContainer as Dropdown, ToolbarButton } from '@atlaskit/editor-common/ui-menu';
import ChevronDownIcon from '@atlaskit/icon/utility/migration/chevron-down';
import { fg } from '@atlaskit/platform-feature-flags';
import Alignment from '../Alignment';
import { IconMap } from './icon-map';
import { triggerWrapper, wrapper } from './styles';
// eslint-disable-next-line @repo/internal/react/no-class-components
export var AlignmentToolbar = /*#__PURE__*/function (_React$Component) {
  _inherits(AlignmentToolbar, _React$Component);
  var _super = _createSuper(AlignmentToolbar);
  function AlignmentToolbar() {
    var _this;
    _classCallCheck(this, AlignmentToolbar);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "toolbarItemRef", /*#__PURE__*/React.createRef());
    _defineProperty(_assertThisInitialized(_this), "state", {
      isOpen: false
    });
    _defineProperty(_assertThisInitialized(_this), "changeAlignment", function (align, togglePopup) {
      if (togglePopup) {
        _this.toggleOpen();
      }
      return _this.props.changeAlignment(align);
    });
    _defineProperty(_assertThisInitialized(_this), "toggleOpen", function () {
      _this.setState({
        isOpen: !_this.state.isOpen
      });
    });
    _defineProperty(_assertThisInitialized(_this), "toggleOpenByKeyboard", function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        _this.setState({
          isOpen: !_this.state.isOpen
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "hide", function (attrs) {
      if (_this.state.isOpen) {
        _this.setState({
          isOpen: false
        });
        if ((attrs === null || attrs === void 0 ? void 0 : attrs.event) instanceof KeyboardEvent && attrs.event.key === 'Escape') {
          var _this$toolbarItemRef;
          (_this$toolbarItemRef = _this.toolbarItemRef) === null || _this$toolbarItemRef === void 0 || (_this$toolbarItemRef = _this$toolbarItemRef.current) === null || _this$toolbarItemRef === void 0 || _this$toolbarItemRef.focus();
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "hideOnEscape", function () {
      var _this$toolbarItemRef2;
      _this.hide();
      (_this$toolbarItemRef2 = _this.toolbarItemRef) === null || _this$toolbarItemRef2 === void 0 || (_this$toolbarItemRef2 = _this$toolbarItemRef2.current) === null || _this$toolbarItemRef2 === void 0 || _this$toolbarItemRef2.focus();
    });
    _defineProperty(_assertThisInitialized(_this), "onOpenChange", function () {
      _this.setState({
        isOpen: false
      });
    });
    return _this;
  }
  _createClass(AlignmentToolbar, [{
    key: "render",
    value: function render() {
      var _pluginState$align,
        _this2 = this;
      var isOpen = this.state.isOpen;
      var _this$props = this.props,
        popupsMountPoint = _this$props.popupsMountPoint,
        popupsBoundariesElement = _this$props.popupsBoundariesElement,
        popupsScrollableElement = _this$props.popupsScrollableElement,
        isReducedSpacing = _this$props.isReducedSpacing,
        pluginState = _this$props.pluginState,
        disabled = _this$props.disabled,
        intl = _this$props.intl,
        api = _this$props.api;
      var alignment = (_pluginState$align = pluginState === null || pluginState === void 0 ? void 0 : pluginState.align) !== null && _pluginState$align !== void 0 ? _pluginState$align : 'start';
      var title = intl.formatMessage(messages.alignment);
      return (
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        jsx("span", {
          css: wrapper
        }, jsx(Dropdown, {
          mountTo: popupsMountPoint,
          boundariesElement: popupsBoundariesElement,
          scrollableElement: popupsScrollableElement,
          isOpen: isOpen,
          handleClickOutside: function handleClickOutside(event) {
            if (event instanceof MouseEvent) {
              _this2.hide({
                isOpen: false,
                event: event
              });
            }
          },
          onOpenChange: this.onOpenChange,
          handleEscapeKeydown: this.hideOnEscape,
          arrowKeyNavigationProviderOptions: {
            type: ArrowKeyNavigationType.MENU
          },
          fitWidth: 112,
          fitHeight: 80,
          closeOnTab: true,
          trigger: jsx(ToolbarButton, {
            spacing: isReducedSpacing ? 'none' : 'default',
            disabled: disabled,
            selected: isOpen,
            title: title
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            ,
            className: "align-btn",
            "aria-label": title,
            "aria-expanded": isOpen,
            "aria-haspopup": true,
            onClick: this.toggleOpen,
            onKeyDown: this.toggleOpenByKeyboard,
            iconBefore: jsx("div", {
              css:
              // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
              fg('platform-visual-refresh-icons') ?
              // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
              triggerWrapperStylesWithPadding :
              // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
              triggerWrapper
            }, jsx(IconMap, {
              alignment: alignment
            }), jsx("span", {
              css: [
              // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
              fg('platform-visual-refresh-icons') &&
              //eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
              expandIconContainerStyle]
            }, jsx(ChevronDownIcon, {
              label: "",
              color: "currentColor",
              LEGACY_margin: "0 0 0 -8px"
            }))),
            ref: this.toolbarItemRef
          })
        }, jsx(Alignment, {
          onClick: function onClick(align) {
            return _this2.changeAlignment(align, false);
          },
          selectedAlignment: alignment
        })), !(api !== null && api !== void 0 && api.primaryToolbar) && /* eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage */
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        jsx("span", {
          css: separatorStyles
        }))
      );
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;
      if (this.state.isOpen) {
        // by triggering the keyboard event with a setTimeout, we ensure that the tooltip
        // associated with the alignment button doesn't render until the next render cycle
        // where the popup will be correctly positioned and the relative position of the tooltip
        // will not overlap with the button.
        setTimeout(function () {
          var _this3$toolbarItemRef;
          var keyboardEvent = new KeyboardEvent('keydown', {
            bubbles: true,
            key: 'ArrowDown'
          });
          (_this3$toolbarItemRef = _this3.toolbarItemRef.current) === null || _this3$toolbarItemRef === void 0 || _this3$toolbarItemRef.dispatchEvent(keyboardEvent);
        }, 0);
      }
    }
  }]);
  return AlignmentToolbar;
}(React.Component);
_defineProperty(AlignmentToolbar, "displayName", 'AlignmentToolbar');
export default injectIntl(AlignmentToolbar);